import { ShowIf } from '../../../../components/ShowIf';
import { ExitType } from '@apply/constants';
import { ExitTypeField } from './components/ExitTypeField';
import { ExpectedListingPrice } from '../../../components/ExpectedListingPrice';
import { useExitType } from '../../../../../queries/PropertyFields';
import { ExpectedTakeOutLoanAmount } from './components/ExpectedTakeOutLoanAmount';

interface ExitInformationProps {
    structureType: string | undefined;
    propertyGuid: string;
    isReview?: boolean;
}

export const ExitInformation: React.FC<ExitInformationProps> = ({ structureType, propertyGuid, isReview = false }) => {
    const [exitType] = useExitType(propertyGuid);

    return (
        <>
            <ExitTypeField
                propertyGuid={propertyGuid}
                required={true}
                isReview={isReview}
            />
            <ShowIf showIf={exitType == ExitType.Sale}>
                <ExpectedListingPrice
                    structureType={structureType}
                    propertyGuid={propertyGuid}
                    required={exitType == ExitType.Sale}
                    isReview={isReview}
                />
            </ShowIf>
            <ShowIf showIf={exitType == ExitType.Refinance}>
                <ExpectedTakeOutLoanAmount
                    structureType={structureType}
                    propertyGuid={propertyGuid}
                    required={exitType == ExitType.Refinance}
                    isReview={isReview}
                />
            </ShowIf>
        </>
    );
};
